/* tslint:disable */
/* eslint-disable */
/**
 * PopshopLive API
 * PopshopLive API service
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    AddListingsToLiveStreamInBatchDto,
    AddListingsToLiveStreamInBatchResponse,
    AddLiveStreamListingRequest,
    BatchRemoveLiveStreamListingDiscountPriceRequest,
    BatchUpdateLiveStreamListingDiscountPriceRequest,
    CreateLiveStreamListingRequest,
    EditLiveStreamListingRequest,
} from '../models';

export interface LivestreamListingApiControllerAddListingsInBatchRequest {
    liveStreamId: string;
    addListingsToLiveStreamInBatchDto: AddListingsToLiveStreamInBatchDto;
}

export interface LivestreamListingApiControllerAddLiveStreamListingRequest {
    liveStreamId: string;
    addLiveStreamListingRequest: AddLiveStreamListingRequest;
}

export interface LivestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceRequest {
    liveStreamId: string;
}

export interface LivestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySellerRequest {
    storeId: string;
    liveStreamId: string;
    batchRemoveLiveStreamListingDiscountPriceRequest: BatchRemoveLiveStreamListingDiscountPriceRequest;
}

export interface LivestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceRequest {
    liveStreamId: string;
    batchUpdateLiveStreamListingDiscountPriceRequest: BatchUpdateLiveStreamListingDiscountPriceRequest;
}

export interface LivestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySellerRequest {
    storeId: string;
    liveStreamId: string;
    batchUpdateLiveStreamListingDiscountPriceRequest: BatchUpdateLiveStreamListingDiscountPriceRequest;
}

export interface LivestreamListingApiControllerCreateLiveStreamListingBySellerRequest {
    liveStreamId: string;
    createLiveStreamListingRequest: CreateLiveStreamListingRequest;
}

export interface LivestreamListingApiControllerDeleteLiveStreamListingRequest {
    liveStreamId: string;
    listingId: string;
}

export interface LivestreamListingApiControllerEditStoreListingRequest {
    liveStreamId: string;
    listingId: string;
    editLiveStreamListingRequest: EditLiveStreamListingRequest;
}

export interface LivestreamListingApiControllerFeatureLiveStreamListingRequest {
    liveStreamId: string;
    listingId: string;
}

export interface LivestreamListingApiControllerMoveListingToTopRequest {
    liveStreamId: string;
    listingId: string;
}

/**
 * 
 */
export class LiveStreamListingApi extends runtime.BaseAPI {

    /**
     */
    async livestreamListingApiControllerAddListingsInBatchRaw(requestParameters: LivestreamListingApiControllerAddListingsInBatchRequest): Promise<runtime.ApiResponse<AddListingsToLiveStreamInBatchResponse>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerAddListingsInBatch.');
        }

        if (requestParameters.addListingsToLiveStreamInBatchDto === null || requestParameters.addListingsToLiveStreamInBatchDto === undefined) {
            throw new runtime.RequiredError('addListingsToLiveStreamInBatchDto','Required parameter requestParameters.addListingsToLiveStreamInBatchDto was null or undefined when calling livestreamListingApiControllerAddListingsInBatch.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings:batch`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addListingsToLiveStreamInBatchDto,
        });

        return new runtime.JSONApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerAddListingsInBatch(requestParameters: LivestreamListingApiControllerAddListingsInBatchRequest): Promise<AddListingsToLiveStreamInBatchResponse> {
        const response = await this.livestreamListingApiControllerAddListingsInBatchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async livestreamListingApiControllerAddLiveStreamListingRaw(requestParameters: LivestreamListingApiControllerAddLiveStreamListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerAddLiveStreamListing.');
        }

        if (requestParameters.addLiveStreamListingRequest === null || requestParameters.addLiveStreamListingRequest === undefined) {
            throw new runtime.RequiredError('addLiveStreamListingRequest','Required parameter requestParameters.addLiveStreamListingRequest was null or undefined when calling livestreamListingApiControllerAddLiveStreamListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings:importFromStoreListings`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.addLiveStreamListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerAddLiveStreamListing(requestParameters: LivestreamListingApiControllerAddLiveStreamListingRequest): Promise<void> {
        await this.livestreamListingApiControllerAddLiveStreamListingRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceRaw(requestParameters: LivestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPrice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:batch-remove-discount-price`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPrice(requestParameters: LivestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceRequest): Promise<void> {
        await this.livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySellerRaw(requestParameters: LivestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySellerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySeller.');
        }

        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySeller.');
        }

        if (requestParameters.batchRemoveLiveStreamListingDiscountPriceRequest === null || requestParameters.batchRemoveLiveStreamListingDiscountPriceRequest === undefined) {
            throw new runtime.RequiredError('batchRemoveLiveStreamListingDiscountPriceRequest','Required parameter requestParameters.batchRemoveLiveStreamListingDiscountPriceRequest was null or undefined when calling livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/live-streams/{liveStreamId}:batchRemoveDiscountPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchRemoveLiveStreamListingDiscountPriceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySeller(requestParameters: LivestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySellerRequest): Promise<void> {
        await this.livestreamListingApiControllerBatchRemoveLiveStreamListingDiscountPriceBySellerRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceRaw(requestParameters: LivestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPrice.');
        }

        if (requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest === null || requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest === undefined) {
            throw new runtime.RequiredError('batchUpdateLiveStreamListingDiscountPriceRequest','Required parameter requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest was null or undefined when calling livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPrice.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}:batch-update-discount-price`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPrice(requestParameters: LivestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceRequest): Promise<void> {
        await this.livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySellerRaw(requestParameters: LivestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySellerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.storeId === null || requestParameters.storeId === undefined) {
            throw new runtime.RequiredError('storeId','Required parameter requestParameters.storeId was null or undefined when calling livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySeller.');
        }

        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySeller.');
        }

        if (requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest === null || requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest === undefined) {
            throw new runtime.RequiredError('batchUpdateLiveStreamListingDiscountPriceRequest','Required parameter requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest was null or undefined when calling livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/stores/{storeId}/live-streams/{liveStreamId}:batchUpdateDiscountPrice`.replace(`{${"storeId"}}`, encodeURIComponent(String(requestParameters.storeId))).replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.batchUpdateLiveStreamListingDiscountPriceRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySeller(requestParameters: LivestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySellerRequest): Promise<void> {
        await this.livestreamListingApiControllerBatchUpdateLiveStreamListingDiscountPriceBySellerRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerCreateLiveStreamListingBySellerRaw(requestParameters: LivestreamListingApiControllerCreateLiveStreamListingBySellerRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerCreateLiveStreamListingBySeller.');
        }

        if (requestParameters.createLiveStreamListingRequest === null || requestParameters.createLiveStreamListingRequest === undefined) {
            throw new runtime.RequiredError('createLiveStreamListingRequest','Required parameter requestParameters.createLiveStreamListingRequest was null or undefined when calling livestreamListingApiControllerCreateLiveStreamListingBySeller.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.createLiveStreamListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerCreateLiveStreamListingBySeller(requestParameters: LivestreamListingApiControllerCreateLiveStreamListingBySellerRequest): Promise<void> {
        await this.livestreamListingApiControllerCreateLiveStreamListingBySellerRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerDeleteLiveStreamListingRaw(requestParameters: LivestreamListingApiControllerDeleteLiveStreamListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerDeleteLiveStreamListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling livestreamListingApiControllerDeleteLiveStreamListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings/{listingId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerDeleteLiveStreamListing(requestParameters: LivestreamListingApiControllerDeleteLiveStreamListingRequest): Promise<void> {
        await this.livestreamListingApiControllerDeleteLiveStreamListingRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerEditStoreListingRaw(requestParameters: LivestreamListingApiControllerEditStoreListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerEditStoreListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling livestreamListingApiControllerEditStoreListing.');
        }

        if (requestParameters.editLiveStreamListingRequest === null || requestParameters.editLiveStreamListingRequest === undefined) {
            throw new runtime.RequiredError('editLiveStreamListingRequest','Required parameter requestParameters.editLiveStreamListingRequest was null or undefined when calling livestreamListingApiControllerEditStoreListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings/{listingId}`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.editLiveStreamListingRequest,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerEditStoreListing(requestParameters: LivestreamListingApiControllerEditStoreListingRequest): Promise<void> {
        await this.livestreamListingApiControllerEditStoreListingRaw(requestParameters);
    }

    /**
     * please use moveListingToTop
     */
    async livestreamListingApiControllerFeatureLiveStreamListingRaw(requestParameters: LivestreamListingApiControllerFeatureLiveStreamListingRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerFeatureLiveStreamListing.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling livestreamListingApiControllerFeatureLiveStreamListing.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings/{listingId}:feature`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     * please use moveListingToTop
     */
    async livestreamListingApiControllerFeatureLiveStreamListing(requestParameters: LivestreamListingApiControllerFeatureLiveStreamListingRequest): Promise<void> {
        await this.livestreamListingApiControllerFeatureLiveStreamListingRaw(requestParameters);
    }

    /**
     */
    async livestreamListingApiControllerMoveListingToTopRaw(requestParameters: LivestreamListingApiControllerMoveListingToTopRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.liveStreamId === null || requestParameters.liveStreamId === undefined) {
            throw new runtime.RequiredError('liveStreamId','Required parameter requestParameters.liveStreamId was null or undefined when calling livestreamListingApiControllerMoveListingToTop.');
        }

        if (requestParameters.listingId === null || requestParameters.listingId === undefined) {
            throw new runtime.RequiredError('listingId','Required parameter requestParameters.listingId was null or undefined when calling livestreamListingApiControllerMoveListingToTop.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("bearer", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/live-streams/{liveStreamId}/listings/{listingId}:moveToTop`.replace(`{${"liveStreamId"}}`, encodeURIComponent(String(requestParameters.liveStreamId))).replace(`{${"listingId"}}`, encodeURIComponent(String(requestParameters.listingId))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async livestreamListingApiControllerMoveListingToTop(requestParameters: LivestreamListingApiControllerMoveListingToTopRequest): Promise<void> {
        await this.livestreamListingApiControllerMoveListingToTopRaw(requestParameters);
    }

}
